import {EditGuesser, FieldGuesser, ShowGuesser} from "@api-platform/admin";
import {
    BooleanInput,
    DatagridConfigurable,
    EditButton,
    ExportButton,
    FilterButton,
    List,
    ReferenceField,
    ReferenceInput,
    SearchInput,
    SelectColumnsButton,
    ShowButton,
    TextInput,
    TopToolbar,
    AutocompleteInput,
} from 'react-admin';
import React from "react";

const SignageDeviceListActions = () => (
    <TopToolbar>
        <SelectColumnsButton/>
        <FilterButton/>
        <ExportButton/>
    </TopToolbar>
);

const signageDeviceFilters = [
    <SearchInput source="q" alwaysOn/>,
    <ReferenceInput source="communaute" reference="communautes" label="Communauté">
        <AutocompleteInput optionText="titre" label="Communauté"/>
    </ReferenceInput>,
];

export const SignageDeviceList = props => (
    <List {...props} actions={<SignageDeviceListActions/>} filters={signageDeviceFilters}>
        <DatagridConfigurable rowClick="show">
            <FieldGuesser source="nom" label="Nom"/>
            <ReferenceField reference="communautes" source="communaute" label="Communauté">
                <FieldGuesser source="titre" label="Titre"/>
            </ReferenceField>
            <ReferenceField reference="utilisateurs" source="utilisateur" label="Utilisateur">
                <FieldGuesser source="name" label="Nom"/>
            </ReferenceField>
            <FieldGuesser source="actif" label="Actif"/>
            <FieldGuesser source="sessionId" label="Identifiant de session"/>
            <FieldGuesser source="createdAt" label="Créé le"/>
            <FieldGuesser source="revokedAt" label="Révoqué le"/>
            <ShowButton/>
            <EditButton/>
        </DatagridConfigurable>
    </List>
);

export const SignageDeviceShow = props => (
    <ShowGuesser {...props}>
        <FieldGuesser source="nom" label="Nom"/>
        <ReferenceField reference="communautes" source="communaute" label="Communauté">
            <FieldGuesser source="titre" label="Titre"/>
        </ReferenceField>
        <ReferenceField reference="utilisateurs" source="utilisateur" label="Utilisateur">
            <FieldGuesser source="name" label="Nom"/>
        </ReferenceField>
        <FieldGuesser source="actif" label="Actif"/>
        <FieldGuesser source="sessionId" label="Identifiant de session"/>
        <FieldGuesser source="createdAt" label="Créé le"/>
        <FieldGuesser source="revokedAt" label="Révoqué le"/>
    </ShowGuesser>
);

const SignageDeviceEditActions = () => <TopToolbar></TopToolbar>;

export const SignageDeviceEdit = props => (
    <EditGuesser {...props} actions={<SignageDeviceEditActions/>}>
        <TextInput source="nom" label="Nom"/>
        <BooleanInput source="actif" label="Actif"/>
        <ReferenceField reference="communautes" source="communaute" label="Communauté">
            <FieldGuesser source="titre" label="Titre"/>
        </ReferenceField>
        <ReferenceField reference="utilisateurs" source="utilisateur" label="Utilisateur">
            <FieldGuesser source="name" label="Nom"/>
        </ReferenceField>
        <FieldGuesser source="sessionId" label="Identifiant de session"/>
        <FieldGuesser source="createdAt" label="Créé le"/>
        <FieldGuesser source="revokedAt" label="Révoqué le"/>
    </EditGuesser>
);
